import React from 'react'
import "./Styles/Collabarator.css"

function Collabarator() {
  return (
    <div className="collabarator-container">
        <h1 className="collabarators-heading">Our Collabarators</h1>
        <div className="collabarator-img">

        </div>
    </div>
  )
}

export default Collabarator